<template>
    <div class="advanced-search-result">
        <h3>{{langAdvancedSearchResult.advancedSearchResult[locale]}}</h3>
        <div class="container" v-if="loading">
            <font-awesome-icon class="spinner" size="2x" icon="circle-notch" :spin="true"/>
        </div>
        <div class="container" v-else-if="items.length > 0">
            <post v-for="item in items"  v-bind:key="item._id" :post="item" style="margin: 5px"/>
            <br />
            <br />
            <b-pagination align="center" size="md" :total-rows="total" v-model="currentPage" :per-page="itemsPerPage" @change="pageClicked">
            </b-pagination>
        </div>
        <div class="container" v-else>
            <b-alert show variant="danger" v-if="statusOk === false && errMessage">{{errMessage}}</b-alert>
            <strong class="no-result" v-else-if="statusOk">{{langAdvancedSearchResult.noPostFound[locale]}}</strong>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Post from "@/components/Post";
//import NettipyoraButton from "@/components/NettipyoraButton";
import { mapState } from 'vuex';
import langAdvancedSearchResult from '@/store/lang/advancedSearchResult';

export default {
    name: "advanced-search-result",
    components: {
        Post//, NettipyoraButton
    },
    data() {
        return  {
            langAdvancedSearchResult,
            currentPage: 1
        }
    },
    computed: mapState({
        loading: state => state.AdvancedSearchResult.loading,
        statusOk: state => state.AdvancedSearchResult.statusOk,
        okMessage: state => state.AdvancedSearchResult.okMessage,
        errMessage: state => state.AdvancedSearchResult.errMessage,
        items: state => state.AdvancedSearchResult.items,
        total: state => state.AdvancedSearchResult.total,
        itemsPerPage: state => state.AdvancedSearchResult.itemsPerPage,
        locale: state => state.locale
    }),
    mounted() {
        //console.log("query",this.$route.query.query);
        this.$store.dispatch('ADVANCED_SEARCH_RESULT_FETCH_POSTS', {query: this.$route.query.query});
    },
    methods: {
        pageClicked(newPageNum) {
            this.currentPage = newPageNum;
            const query = `${this.$route.query.query}&page=${this.currentPage}`;
            this.$router.replace({query: {query}});
            this.$store.dispatch('ADVANCED_SEARCH_RESULT_FETCH_POSTS', {query: query});
        }
    }
}
</script>

<style scoped lang="scss">
.advanced-search-result {
  margin: 1em;

  .spinner, .no-result {
    margin: 2em;
  }
}
</style>
